/* =====================================================
   STREETWEAR INTERACTIONS — bhmanstore.com
   Replaces 3D tilt with sharp, high-end hover states
   Author: Google Anti Gravity
   ===================================================== */

(function () {
  'use strict';

  /* ── 1. Kill old glassmorphism tilt handlers ──────── */
  document.querySelectorAll('.m-product-card').forEach(card => {
    const clone = card.cloneNode(true);
    card.parentNode.replaceChild(clone, card);
  });

  /* ── 2. Re-attach sharp hover interactions ─────────── */
  function initCardHovers() {
    document.querySelectorAll('.m-product-card').forEach(card => {
      const img = card.querySelector(
        '.m-product-card__main-image img, .m-product-card__media img'
      );

      card.addEventListener('mouseenter', () => {
        card.style.transform = 'none';
        if (img) img.style.transform = 'scale(1.06)';
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform = 'none';
        if (img) img.style.transform = 'scale(1)';
      });
    });
  }

  /* ── 3. Scroll-reveal: sharp fade-up ──────────────── */
  function initScrollReveal() {
    const targets = document.querySelectorAll(
      '.m-product-card, .m-section-header, .m-collection-header, .m-index-section-header'
    );

    const style = document.createElement('style');
    style.textContent = `
      .meech-reveal {
        opacity: 0;
        transform: translateY(24px);
        transition: opacity 0.55s cubic-bezier(0.16,1,0.3,1),
                    transform 0.55s cubic-bezier(0.16,1,0.3,1);
      }
      .meech-reveal.meech-visible {
        opacity: 1;
        transform: translateY(0);
      }
    `;
    document.head.appendChild(style);

    targets.forEach((el, i) => {
      el.classList.add('meech-reveal');
      el.style.transitionDelay = `${(i % 8) * 0.06}s`;
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('meech-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(el => observer.observe(el));
  }

  /* ── 4. Header: Add visible class on scroll ─────── */
  function initStickyHeader() {
    const header = document.querySelector('.m-header, header');
    if (!header) return;
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 60) {
        header.style.background = 'rgba(0,0,0,0.97)';
      } else {
        header.style.background = 'rgba(0,0,0,0.85)';
      }
      last = y;
    }, { passive: true });
  }

  /* ── 5. Mobile drawer: bold font override ─────────── */
  function initDrawerTypography() {
    const drawers = document.querySelectorAll('.m-menu-drawer, [class*="m-drawer"], [class*="drawer"]');
    drawers.forEach(drawer => {
      drawer.querySelectorAll('a').forEach(link => {
        link.style.fontFamily = "'Outfit', 'Inter', sans-serif";
        link.style.fontWeight = '900';
        link.style.textTransform = 'uppercase';
        link.style.letterSpacing = '-0.02em';
      });
    });
  }

  /* ── 6. Announce bar marquee speed-up ────────────── */
  function initAnnouncementMarquee() {
    const bars = document.querySelectorAll('[class*="annoucement"], [class*="announcement"]');
    bars.forEach(bar => {
      bar.style.animationDuration = '18s';
    });
  }

  /* ── Boot ─────────────────────────────────────────── */
  function boot() {
    initCardHovers();
    initScrollReveal();
    initStickyHeader();
    initDrawerTypography();
    initAnnouncementMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-run on Shopify section re-renders (theme editor) */
  document.addEventListener('shopify:section:load', () => {
    initCardHovers();
    initScrollReveal();
  });

})();
